var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from "classnames";
import React from "react";
import styles from "./IconMenu.module.scss";
export function IconMenuButton(_a) {
    var _b;
    var children = _a.children, icon = _a.icon, active = _a.active, props = __rest(_a, ["children", "icon", "active"]);
    return (React.createElement("button", __assign({ className: classNames(styles.menuButton, (_b = {}, _b[styles.active] = active, _b)) }, props),
        icon && React.createElement("span", { className: styles.icon }, icon),
        React.createElement("span", null, children)));
}
